import { menus } from '../../../util/route/menus';
import DropdownMenu from './Menu/DropdownMenu/DropdownMenu';
import DirectNavLink from './Menu/DirectNavLink';
import Minimize from './Minimize';
import Time from './Time/Time';
import { useAppSelector } from '../../../hook/useAppSelector';
import ThemeToggle from './Theme/ThemeToggle';
import { useAppDispatch } from '../../../hook/useAppDispatch';
import { ThemeEnum } from '../../../enum/Theme';
import { setTheme, saveConfigToBackend } from '../../../store/slice/config/config';

interface SidebarProps {
  handleClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ handleClose }) => {
  const isSidebarMinimized = useAppSelector((state) => state.configSlice.isSidebarMinimized);
  const isMobile = useAppSelector((state) => state.configSlice.isMobile);

  const theme = useAppSelector((state) => state.configSlice.theme);
  const dispatch = useAppDispatch();

  const handleThemeToggle = () => {
    const newTheme = theme === ThemeEnum.DARK ? ThemeEnum.LIGHT : ThemeEnum.DARK;

    dispatch(setTheme(newTheme));
    dispatch(saveConfigToBackend({ theme: newTheme }));
  };

  return (
    <div className={`sidebar ${isSidebarMinimized ? 'minimized' : ''}`}>
      <ThemeToggle theme={theme} onToggle={handleThemeToggle} />

      {!isSidebarMinimized && !isMobile && <Time></Time>}

      {!isMobile && <Minimize></Minimize>}

      {menus.map((menu) => (
        <div key={`menu.sidebarMenuType${menu.sidebarMenuType}`}>
          {menu.routes ? (
            <DropdownMenu
              sidebarMenuType={menu.sidebarMenuType}
              icon={menu.icon}
              title={menu.label}
              menuRoutes={menu.routes}
            ></DropdownMenu>
          ) : (
            <DirectNavLink
              sidebarMenuType={menu.sidebarMenuType}
              icon={menu.icon}
              path={menu.path}
              label={menu.label}
              handleClose={handleClose}
            ></DirectNavLink>
          )}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
